export default __webpack_public_path__ + "static/media/WWW-logo.1e558311.png";